import { Sun, Moon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useGameAppearance } from '@/contexts/GameAppearanceContext'
import { cn } from '@/lib/utils'

interface ThemeToggleProps {
  showTooltip?: boolean
  className?: string
}

// Alterna a aparencia claro/escuro DA MESA (escopada a sessao); o tema da
// conta (ThemeContext) nao e afetado.
export function ThemeToggle({ showTooltip = false, className }: ThemeToggleProps) {
  const { appearance, resolvedAppearance, setAppearance } = useGameAppearance()

  const toggleAppearance = () => {
    if (appearance === 'dark') {
      setAppearance('light')
    } else if (appearance === 'light') {
      setAppearance('system')
    } else {
      setAppearance('dark')
    }
  }

  const Icon = resolvedAppearance === 'dark' ? Moon : Sun

  return (
    <div className={cn("group relative", className)}>
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleAppearance}
        className={cn(
          "h-8 w-8 transition-all duration-300",
          "text-game-secondary hover:text-game-primary",
          "hover:bg-game-hover rounded-full"
        )}
        title={`Tema: ${appearance === 'system' ? 'Sistema' : appearance === 'dark' ? 'Escuro' : 'Claro'}`}
      >
        <Icon className={cn(
          "h-4 w-4 transition-all duration-300",
          resolvedAppearance === 'dark' ? "rotate-0" : "rotate-180"
        )} />
      </Button>
      {showTooltip && (
        <span className="absolute left-full ml-3 px-2 py-1 text-xs font-medium text-white bg-slate-800 dark:bg-zinc-800 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50 shadow-lg">
          Tema
        </span>
      )}
    </div>
  )
}
